import { render, staticRenderFns } from "./releaseDialog.vue?vue&type=template&id=17b97248&scoped=true&"
import script from "./releaseDialog.vue?vue&type=script&lang=js&"
export * from "./releaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./releaseDialog.vue?vue&type=style&index=0&id=17b97248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b97248",
  null
  
)

export default component.exports